export default __webpack_public_path__ + "assets/142eb272fde9417b5592cea926743a88.png";